import { CloseIcon } from "assets/icons";
import { CSSProperties } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DateInput } from "ui";

import { FilterFormValues } from "../OrdersFilterForm.types";

import styles from "../OrdersFilterForm.module.scss";

const toLocalStartOfDayIso = (date: Date): string =>
  new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    0,
    0,
    0,
    0
  ).toISOString();

const toLocalEndOfDayIso = (date: Date): string =>
  new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    23,
    59,
    59,
    999
  ).toISOString();

const parseIso = (iso: string | null | undefined): Date | null => {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
};

const clearButtonStyle: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 20,
  height: 20,
  marginLeft: 4,
  padding: 0,
  border: "none",
  background: "transparent",
  color: "#9b9b9b",
  cursor: "pointer"
};

const ClearButton = ({ onClick }: { onClick: () => void }) => (
  <button
    type="button"
    style={clearButtonStyle}
    onClick={onClick}
    aria-label="Clear"
  >
    <CloseIcon width={12} height={12} />
  </button>
);

export const DateRangeBlock = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<FilterFormValues>();

  return (
    <div className={styles.orderFilterForm__block}>
      <h4 className={styles.orderFilterForm__block__title}>
        {t("Date of order placement")}
      </h4>

      <div className={styles.orderFilterForm__block__box}>
        <Controller
          control={control}
          name="createdFrom"
          render={({ field: { value, onChange } }) => (
            <DateInput
              label={t("From")}
              value={parseIso(value)}
              onChange={(d) => onChange(d ? toLocalStartOfDayIso(d) : undefined)}
              action={
                value ? (
                  <ClearButton onClick={() => onChange(undefined)} />
                ) : null
              }
            />
          )}
        />

        <Controller
          control={control}
          name="createdTo"
          render={({ field: { value, onChange } }) => (
            <DateInput
              label={t("To")}
              value={parseIso(value)}
              onChange={(d) => onChange(d ? toLocalEndOfDayIso(d) : undefined)}
              action={
                value ? (
                  <ClearButton onClick={() => onChange(undefined)} />
                ) : null
              }
            />
          )}
        />
      </div>
    </div>
  );
};
